<template>
    <div class="ah-panel audit-flow-table">
        <div class="panel-header small feature">
            <div class="panel-title">{{ typeName }}流程</div>
            <div class="panel-action"></div>
        </div>
        <div class="panel-body">
            <center>
                <el-radio-group v-model="setting.isEnable" @change="onAuditFlowEnableChange" :disabled="!editable || !isActionEnable || isQR()">
                    <el-radio-button :label="false">簡易流程</el-radio-button>
                    <el-radio-button :label="true">自訂流程</el-radio-button>
                </el-radio-group>
            </center>
            <el-table :data="setting.settings" v-if="setting" v-loading="loading || selfLoading" empty-text="沒有資料">
                <el-table-column prop="startAmount" label="金額範圍" width="280">
                    <template slot-scope="scope">
                        <div v-if="editingSettingSno == scope.row.sno && type != 'invoiceAuditFlowSetting'">
                            <el-row :gutter="0">
                                <el-col :span="11">
                                    <money-input v-model="scope.row.startAmount" />
                                </el-col>
                                <el-col :span="2">
                                    <center style="padding-top: 5px">~</center>
                                </el-col>
                                <el-col :span="11">
                                    <money-input v-model="scope.row.endAmount" />
                                </el-col>
                            </el-row>
                        </div>
                        <div v-else>
                            <div v-if="scope.row.startAmount == 0 && scope.row.endAmount == 0">
                                全部
                            </div>
                            <div v-else>
                                <Money :v="scope.row.startAmount" /> ~
                                <Money :v="scope.row.endAmount" />
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="" label="審核流程">
                    <template slot-scope="scope">
                        <!-- 編輯流程 -->
                        <div v-if="editingSettingSno == scope.row.sno" class="ah-audit-flow-steps">
                            <span class="step still">申請</span>
                            <el-button v-if="!isQR()" type="primary" class="add-btn" icon="el-icon-plus" size="small" @click="onAddStepClick(scope.row)"></el-button>
                            <draggable v-model="scope.row.steps" draggable=".draggable" animation="300" style="display: inline-block">
                                <span
                                    v-for="step in scope.row.steps"
                                    :key="step.sno"
                                    :class="{
                                        step: true,
                                        editable: true,
                                        draggable: step.rolE_TYP != 3
                                    }"
                                    v-show="step.rolE_TYP != 0 && step.rolE_TYP != 3"
                                >
                                    <span v-if="step.rolE_TYP != 0 && step.rolE_TYP != 3">
                                        <el-select v-model="step.key" filterable placeholder="請選擇" @change="onStepSelectChange(step)" size="small">
                                            <el-option-group label="身份">
                                                <el-option label="主管" :value="'1/0/主管'"> </el-option>
                                                <el-option v-if="type == 'projectAuditFlowSetting'" label="專案PM" :value="'4/0/專案PM'"> </el-option>
                                                <el-option v-if="type == 'projectAuditFlowSetting'" label="專案經辦人" :value="'5/0/專案經辦人'"> </el-option>
                                            </el-option-group>
                                            <el-option-group label="指定人">
                                                <el-option v-for="staff in staffOptions" :label="staff.label" :value="staff.value" :key="staff.value"> </el-option>
                                            </el-option-group>
                                        </el-select>
                                        <span class="del-btn" @click="onStepDelete(scope.row.steps, step)"></span>
                                    </span>
                                </span>
                            </draggable>
                            <span class="step still">
                                <span v-if="type == 'invoiceAuditFlowSetting'">開立</span>
                                <span v-else>填寫付款明細</span>
                            </span>
                            <span class="step still">
                                <span v-if="type == 'invoiceAuditFlowSetting'">入帳</span>
                                <span v-else>確認付款</span>
                            </span>
                        </div>
                        <!-- 檢視流程 -->
                        <div v-else>
                            <ah-audit-flow-steps :steps="scope.row.steps" />
                        </div>
                    </template>
                </el-table-column>
                <el-table-column v-if="isActionEnable && !isQR()" prop="" label="操作" width="180">
                    <template slot-scope="scope">
                        <div v-if="scope.row.sno != null && editingSettingSno == scope.row.sno">
                            <el-button type="success" @click="onEditSubmitClick(scope.row)">儲存</el-button>
                            <el-button type="danger" @click="onEditCancelClick(scope.row)">取消</el-button>
                        </div>
                        <div v-else-if="scope.row.sno == null">
                            <el-button type="success" @click="onAddSubmitClick(scope.row)">新增</el-button>
                            <el-button type="danger" @click="onAddCancelClick(scope.row)">移除</el-button>
                        </div>
                        <div v-else>
                            <div v-if="setting.isEnable && editable">
                                <el-button type="primary" plain @click="onEditClick(scope.row.sno)">編輯</el-button>
                                <el-button v-if="type != 'invoiceAuditFlowSetting' && setting.settings.length > 1" @click="onDeleteClick(scope.row)">刪除</el-button>
                            </div>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div style="margin-top: 15px" v-if="(setting.isEnable && type != 'invoiceAuditFlowSetting') || (type == 'invoiceAuditFlowSetting' && setting.settings.length == 0)">
                <el-alert v-if="discontinuousIntervals.length" type="error" center :closable="false" style="margin-bottom: 10px">
                    金額範圍有空缺：{{ discontinuousIntervals.join(", ") }}。請修正後再申請請款單/發票。
                </el-alert>
                <el-button v-if="isActionEnable && !isQR()" type="primary" plain size="small" @click="onAddClick">新增金額區間</el-button>
                <div v-if="type == 'projectAuditFlowSetting' && isUsingProjectItem" style="text-align: right; font-size: 9.5pt; color: #888;">* 「專案PM」、「專案經辦人」在專案管理中設定。</div>
            </div>
        </div>
    </div>
</template>
<script>
import _ from 'lodash';
import { mapGetters } from 'vuex';
import draggable from 'vuedraggable';
import ahAuditFlowSteps from '@/components/ui/ahAuditFlowSteps';

export default {
    name: 'audit-flow-table',
    // type:  ex: 'payoutAuditFlowSetting'
    // setting:  ex: auditFlowSettings.payoutAuditFlowSetting
    props: ['type', 'setting', 'loading', 'editable'],
    components: { draggable, ahAuditFlowSteps },
    data() {
        return {
            // 編輯中的 setting Sno
            editingSettingSno: null,
            selfLoading: false,
            staffOptions: [],
            settingsWithKey: [],
        };
    },
    computed: {
        ...mapGetters({
            isAhooAgent: 'account/isAhooAgent',
            isSAAdmin: 'account/isSAAdmin',
        }),
        settings() {
            return this.setting.settings;
        },
        // 轉換 type 編號： 1:發票,2:一般/外幣,3:專案
        typeNum() {
            if (this.type == 'invoiceAuditFlowSetting') return 1;
            if (this.type == 'payoutAuditFlowSetting') return 2;
            if (this.type == 'projectAuditFlowSetting') return 3;
            return null;
        },
        typeName() {
            if (this.type == 'invoiceAuditFlowSetting') return '發票開立';
            if (this.type == 'payoutAuditFlowSetting') return '一般、外幣請款';
            if (this.type == 'projectAuditFlowSetting') return '專案請款';
            return null;
        },
        discontinuousIntervals() {
            const discontinuousList = [];
            let checkNumber = 0;
            let isCreateMode = false;
            this.settings.forEach((item) => {
                if (!item.sno) isCreateMode = true;
                if (checkNumber !== item.startAmount) {
                    discontinuousList.push(`${checkNumber} ~ ${item.startAmount - 1}`);
                }
                checkNumber = item.endAmount + 1;
            });
            if (isCreateMode) discontinuousList.pop();
            return discontinuousList;
        },
        isActionEnable() {
            if (this.isSAAdmin || this.isAhooAgent) return true;
            return this.isPayed('S01');
        },
        isUsingProjectItem() {
            let used = false;
            this.setting.settings.forEach((setting) => {
                if (setting.steps.find((step) => step.menU_UNT === '專案PM' || step.menU_UNT === '專案經辦人' || step.menU_UNT === '專案審核人')) {
                    used = true;
                }
            });
            return used;
        },
    },
    watch: {
        // 監聽 Setting，有更動時，在 step 中增加 key 值（用於選人的下拉選單）
        setting(newValue) {
            const settings = JSON.parse(JSON.stringify(newValue.settings));
            for (const s in settings) {
                settings[s].steps = settings[s].steps.map((step) => ({
                    ...step,
                    key: `${step.rolE_TYP}/${step.elsE_STF_SNO}/${step.menU_UNT}`,
                }));
            }
            this.setting.settings = settings;
        },
    },
    created() {
        this.fetchStaffOptions();
    },
    methods: {
        // 取得下拉選單資料
        fetchStaffOptions() {
            this.$api({
                url: '/AuditFlowSettingPage/GetAuditStaffOptions',
                method: 'GET',
            }).then((resp) => {
                this.staffOptions = resp.data.options
                    .filter((s) => s.sno != 1)
                    .filter((o) => o.grP_NO !== 'OT1')
                    .filter((o) => o.grP_NO !== 'OT2')
                    .filter((o) => o.grP_NO !== 'OT3')
                    .filter((o) => o.grP_NO !== 'OT4')
                    .map((x) => ({
                        value: `2/${x.sno}/${x.nam}`,
                        label: x.nam,
                    }));
            });
        },
        // 按下 簡易流程/自訂流程 切換
        // (發送 自訂流程 enable 的更改)
        onAuditFlowEnableChange() {
            this.selfLoading = true;
            this.$api({
                url: 'AuditFlowSettingPage/UpdateAuditFlowTemplate',
                method: 'POST',
                data: {
                    type: this.typeNum,
                    isEnable: this.setting.isEnable,
                    setting: null, // null = 只更改 isEnable
                },
            })
                .then(() => {
                    this.$emit('onEdited'); // 呼叫 parent 重新載入流程
                })
                .finally(() => {
                    this.selfLoading = false;
                });
        },
        // 按下編輯區間
        onEditClick(sno) {
            this.editingSettingSno = sno;
        },
        // 按下取消編輯區間
        onEditCancelClick() {
            this.editingSettingSno = null;
            this.$emit('onEdited');
        },
        // 按下編輯區間儲存
        onEditSubmitClick(setting) {
            this.selfLoading = true;

            this.$api({
                url: 'AuditFlowSettingPage/UpdateAuditFlowTemplate',
                method: 'POST',
                data: {
                    // 1:發票,2:一般/外幣,3:專案
                    type: this.typeNum,
                    isEnable: this.setting.isEnable,
                    setting: this.clearAddStep(setting),
                },
            })
                .then(() => {
                    // 呼叫 parent 重新載入流程word => word.length > 6
                    this.$emit('onEdited', {
                        type: this.type,
                        sno: setting.sno,
                    });
                    this.editingSettingSno = null;
                })
                .finally(() => {
                    this.selfLoading = false;
                });
        },
        // 新增區間後確認
        onAddSubmitClick(setting) {
            console.log(setting);
            this.selfLoading = true;

            this.$api({
                url: 'AuditFlowSettingPage/UpdateAuditFlowTemplate',
                method: 'POST',
                data: {
                    // 1:發票,2:一般/外幣,3:專案
                    type: this.typeNum,
                    isEnable: this.setting.isEnable,
                    setting: this.clearAddStep(setting),
                },
            })
                .then(() => {
                    // 呼叫 parent 重新載入流程word => word.length > 6
                    this.$emit('onEdited', {
                        type: this.type,
                        sno: setting.sno,
                    });
                })
                .finally(() => {
                    this.selfLoading = false;
                });
        },
        // 新增區間後按移除
        onAddCancelClick(setting) {
            // 直接移除
            if (setting.sno == null) {
                const index = this.setting.settings.indexOf(setting);
                if (index > -1) this.setting.settings.splice(index, 1);
            }
        },
        // 按下區間刪除
        onDeleteClick(setting) {
            this.$confirm(`確定要讓刪除 ${setting.startAmount} ~ ${setting.endAmount} 金額區間？`, {
                confirmButtonText: '確定刪除',
                cancelButtonText: '取消',
            }).then(() => {
                // 預先從介面上移除
                const index = this.setting.settings.indexOf(setting);
                if (index > -1) this.setting.settings.splice(index, 1);

                // api 移除
                this.selfLoading = true;
                this.$api({
                    url: 'AuditFlowSettingPage/DeleteAuditFlowTemplate',
                    method: 'POST',
                    data: {
                        type: this.typeNum,
                        sno: setting.sno,
                    },
                })
                    .then(() => {})
                    .finally(() => {
                        this.$emit('onEdited');
                        this.selfLoading = false;
                    });
            });
        },
        // 按下新增區間
        onAddClick() {
            this.editingSettingSno = null;

            this.setting.settings.push({
                startAmount: 0,
                endAmount: 0,
                sno: null,
                steps: [
                    {
                        sno: null,
                        rolE_TYP: 3,
                        menU_UNT: 'A02',
                        elsE_STF_SNO: 0,
                    },
                    {
                        sno: null,
                        rolE_TYP: 3,
                        menU_UNT: 'A03',
                        elsE_STF_SNO: 0,
                    },
                ],
            });
        },
        // 按下新增步驟 (新增到第一個)
        onAddStepClick(setting) {
            setting.steps.unshift({
                sno: null,
                rolE_TYP: -1,
                menU_UNT: '(未選擇)',
                elsE_STF_SNO: null,
            });
        },
        // 新增/修改步驟時，下拉選單變動（把下拉的 key 值轉換給 rolE_TYP, elsE_STF_SNO)
        // key = rolE_TYP/elsE_STF_SNO/menU_UNT
        onStepSelectChange(step) {
            const parts = step.key.split('/');
            step.rolE_TYP = parseInt(parts[0]);
            step.elsE_STF_SNO = parseInt(parts[1]);
            step.menU_UNT = parts[2];
        },
        onStepDelete(steps, step) {
            const index = steps.indexOf(step);
            if (index > -1) steps.splice(index, 1);
        },
        // 在審核流程中刪除 rolE_TYP == 0 物件（upsert api 不接受 rolE_TYP == 0 的物件 ex: ADD)
        // 還有移除新增了，但未指派的step
        // rolE_TYP: 1:指定主管 2:指定人 3:指定權限 4:PM
        clearAddStep(setting) {
            const newSetting = JSON.parse(JSON.stringify(setting));
            const fixedSteps = newSetting.steps.filter((s) => s.rolE_TYP === 3);

            const cleanSteps = _.chain([...newSetting.steps, ...fixedSteps])
                .filter((s) => s.rolE_TYP > 0)
                .reverse()
                .uniq()
                .reverse()
                .value();

            newSetting.steps = cleanSteps;

            return newSetting;
        },
    },
};
</script>
<style lang="scss">
.audit-flow-table {
}
</style>
